/**
 * fichier qui se charge d'etablir la connexion vers l'API
 * en y ajoutant des informations si necessairs (token ou autre header...)
 */

import Vue from 'vue'
import VueResource from 'vue-resource'
import resourceUrls from './resources'
import toastr from 'toastr/build/toastr.min'
import storeAuth from '../stores/auth'

Vue.use(VueResource)

Vue.http.options.root = process.env.VUE_APP_ROOT_API
Vue.http.options.emulateJSON = false
Vue.http.headers.common['Content-Type'] = 'application/json'

// Interceptor pour rajouter le token et l'identifiant de l'application à chaque requête
Vue.http.interceptors.push(function (request, next) {
    let myToken = localStorage.getItem('token')
    if (myToken) {
        request.headers.set('Authorization', `Bearer ${myToken}`)
    }
    request.params['app'] = 'tod'
    // continue to next interceptor
    next(function (response) {
        if (response.status === 401) {
            storeAuth.dispatch("resetStore")
            toastr.error('Une erreur est survenue', 'Erreur')
        }
        else if (response.status >= 300 || response.status === 0) {
            toastr.error('Une erreur réseau est survenue', 'Erreur')
        }

    })
})

export default {
    getFromUri: (uri) => {
        return Vue.resource(uri)
    },
    getResourceUri: () => {
        return resourceUrls
    }
}